const API_URL = localStorage.getItem('api_url');

const baseUrl = API_URL || process.env.VUE_APP_APP_URL || 'http://localhost:3010';

export default {
    API_URL: baseUrl,
    SOCKET_URL: process.env.VUE_APP_APP_URL || baseUrl,
    DEBUG: true,
};
